import { gql } from '@apollo/client'

export const FETCH_EFFECTIVE_DAILY_MEASUREMENT = gql`
  query effectiveDailyMeasurement($date: String!, $type: HealthDataMeasurementType!) {
    effectiveDailyMeasurement(date: $date, type: $type) {
      date
      type
      selectedSource
      defaultSource
      availableMeasurements {
        id
        type
        title
        value
        values {
          ... on BloodPressureMeasurement {
            systolic
            diastolic
          }
          ... on SingleValueMeasurement {
            value
          }
        }
        units
        description
        occurredAt
        createdAt
        externalSource
      }
    }
  }
`
